<template>
  <div class="editorjs-render-column  p-2 d-flex justify-content-center"><Editorjsrender :align_style="align_style"  :scroll="false"  :blocks_json="block.blocks" ></Editorjsrender></div>
</template>

<script>
import Editorjsrender from "@/models/Editorjsrender";
export default {
  name: "EditorJsColumnRender",
  components: {
    'Editorjsrender': Editorjsrender,
  },
  beforeCreate: function () {

    this.$options.components.Editorjsrender =Editorjsrender;
  },
  mounted(){


  },
  props: ["block",'align_style'],
}
</script>

<style scoped>

</style>